var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * NumberOneFilled component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconNumberOneFilled extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12 23C14.9174 23 17.7153 21.8411 19.7782 19.7782C21.8411 17.7153 23 14.9174 23 12C23 9.08262 21.8411 6.28473 19.7782 4.22183C17.7153 2.15893 14.9174 1 12 1C9.08262 1 6.28473 2.15893 4.22183 4.22183C2.15893 6.28473 1 9.08262 1 12C1 14.9174 2.15893 17.7153 4.22183 19.7782C6.28473 21.8411 9.08262 23 12 23ZM12.9821 7.28571C12.9821 7.02523 12.8787 6.77542 12.6945 6.59123C12.5103 6.40705 12.2605 6.30357 12 6.30357C11.7395 6.30357 11.4897 6.40705 11.3055 6.59123C11.1213 6.77542 11.0179 7.02523 11.0179 7.28571C11.0179 7.65039 10.873 8.00012 10.6151 8.25799C10.3573 8.51585 10.0075 8.66071 9.64286 8.66071H8.85714C8.59666 8.66071 8.34685 8.76419 8.16266 8.94838C7.97848 9.13256 7.875 9.38238 7.875 9.64286C7.875 9.90334 7.97848 10.1531 8.16266 10.3373C8.34685 10.5215 8.59666 10.625 8.85714 10.625H9.64286C10.1331 10.625 10.5983 10.5197 11.0179 10.3296V15.7321H8.85714C8.59666 15.7321 8.34685 15.8356 8.16266 16.0198C7.97848 16.204 7.875 16.4538 7.875 16.7143C7.875 16.9748 7.97848 17.2246 8.16266 17.4088C8.34685 17.593 8.59666 17.6964 8.85714 17.6964H15.1429C15.4033 17.6964 15.6531 17.593 15.8373 17.4088C16.0215 17.2246 16.125 16.9748 16.125 16.7143C16.125 16.4538 16.0215 16.204 15.8373 16.0198C15.6531 15.8356 15.4033 15.7321 15.1429 15.7321H12.9821V7.28571Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconNumberOneFilled.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconNumberOneFilled.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconNumberOneFilled.prototype, "size", void 0);
if (customElements.get('cat-icon-number-one-filled') === undefined) {
    customElements.define('cat-icon-number-one-filled', BlocksIconNumberOneFilled);
}
